import { createContext, useContext } from 'react'

export type OrbitSkinId = 'cream' | 'ivory' | 'glass' | 'ink' | 'outline'
export const ORBIT_SKIN_IDS: readonly OrbitSkinId[] = ['cream', 'ivory', 'glass', 'ink', 'outline'] as const

export interface OrbitSkinContextValue {
  skin: OrbitSkinId
  // setSkin is retained for tests; production path writes to profile via CharacterPage equip flow.
  setSkin?: (id: OrbitSkinId) => void
}

export const OrbitSkinContext = createContext<OrbitSkinContextValue>({ skin: 'cream' })

export const useOrbitSkin = () => useContext(OrbitSkinContext)
